module.exports = __webpack_public_path__ + "img/115.263aba1a.png";